/** What KIND of value an output yields — the useful fact inside the step's
 * own drawer, where "from <this step>" would be tautological. */
export const kindCast = (kind: string, values?: string[]): string => {
  switch (kind) {
    case 'enum':
      return values?.length ? `one of ${values.join(' / ')}` : 'one of a list';
    case 'boolean':
      return 'yes / no';
    case 'number':
      return 'a number';
    default:
      return 'text';
  }
};

export const Pill = ({ children }: { children: React.ReactNode }) => (
  <code className="rounded border border-outline bg-surface-elevated px-1.5 py-0.5 text-xs">
    {children}
  </code>
);
